import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getCookie } from './utils';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: getCookie('Exadel.EIS.Language') || 'en',
        supportedLngs: ['en', 'ru'],
        lng: getCookie('Exadel.EIS.Language') || 'en',
        debug: false,
        ns: ['devices', 'devicesProfilesInfo', 'mobiledevices', 'history', 'usersProfilesInfo', 'assignCountProfile',
            'licenses', 'virtualmachines', 'licensesPaymentsReport', 'licenseVersion', 'licensePayment', 'archive',
            'reports', 'deviceAssignmentReport', 'deviceUnassignmentReport', 'expenseReport', 'orderingReport',
            'deviceManufacturers', 'devicetypes', 'mobileversions', 'generalcategories', 'licensemanufacturers',
            'deviceAssignmentReasons', 'licenseProductAttribute', 'licenseProductName', 'licenseProductVersion',
            'permissions', 'licenseSettings', 'userprofile', 'global', 'googleDrive'],
        fallbackNS: 'global',
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files
        },
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: true
        },
    });

export default i18n;
